import {
  BusinessDays_TOKYO_NAGOYA_OSAKA,
  BusinessDays_FUKUOKA_SAPPORO
} from './business-days'
import { DaysOfWeek } from './date-util'

export default class ClinicConstantsWomenStg {
  /* clinic情報 */
  static SAPPORO = {
    medicalBusinessId: 'c1172203-5b5e-4fa7-9499-28b163f33565', // mensのDクリニック札幌へ
    name: '札幌',
    clinicId: 'baae079dbb8b4f3eb3bca96b346341b7',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_FUKUOKA_SAPPORO,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static TOKYO = {
    medicalBusinessId: '27f6c9d0-4946-4785-82a8-fd89c11858d1',
    name: '東京',
    clinicId: 'bc7fdf0035aa4d90b3aaea9f26915cc5',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: { [DaysOfWeek.WED]: { am: true, pm: false } }
  }

  static NAGOYA = {
    medicalBusinessId: '27f6c9d0-4946-4785-82a8-fd89c11858d1',
    name: '名古屋',
    clinicId: '0dba3c7c6f19494ea5a7a968485d9952',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: {
      [DaysOfWeek.WED]: { am: true, pm: false }
    }
  }

  static OSAKA = {
    medicalBusinessId: '27f6c9d0-4946-4785-82a8-fd89c11858d1',
    name: '大阪',
    clinicId: 'c4d649ad700f48a791642b8819a124ce',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_TOKYO_NAGOYA_OSAKA,
    nonTargetDays: { [DaysOfWeek.WED]: { am: true, pm: false } }
  }

  static FUKUOKA = {
    medicalBusinessId: '27f6c9d0-4946-4785-82a8-fd89c11858d1',
    name: '福岡',
    clinicId: '03df60c9052441cdbdcbab167b31cf14',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays_FUKUOKA_SAPPORO,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static CLINICS = [
    ClinicConstantsWomenStg.SAPPORO,
    ClinicConstantsWomenStg.TOKYO,
    ClinicConstantsWomenStg.NAGOYA,
    ClinicConstantsWomenStg.OSAKA,
    ClinicConstantsWomenStg.FUKUOKA
  ]
}
